import {ConnectionSuggestion} from '../entities';
import {WorkdaysEntityState} from '../workday';
import {WorkspaceReservationsState} from '../workspaceReservation/types';
import {
  connectedUsersAdapter,
  connectionsAdapter,
  connectionSearchResultsAdapter,
  connectionsWorkdaysAdapter,
  connectionsWorkspaceReservationsAdapter,
} from './adapters';
import {ConnectionsSliceState, ConnectionsState, ConnectionUsersState} from './types';

export const initialState: ConnectionsSliceState = {
  connections: <ConnectionsState>connectionsAdapter.getInitialState(),
  connectedUsers: <ConnectionUsersState>connectedUsersAdapter.getInitialState(),
  workspaceReservations: <WorkspaceReservationsState>connectionsWorkspaceReservationsAdapter.getInitialState(),
  workdays: <WorkdaysEntityState>connectionsWorkdaysAdapter.getInitialState(),
  searchResults: <ConnectionUsersState>connectionSearchResultsAdapter.getInitialState(),
  connectionsWithReservations: null,
  isLoadingConnections: true,
  isLoadingWorkspaceReservationsForConnections: true,
  isSearching: false,
  isLoadingConnectionSuggestions: true,
  isSendingConnectionSuggestionsFeedback: false,
  connectionSuggestion: {} as ConnectionSuggestion,
  isConnecting: false,
};
